import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import actions from 'redux-auto'
import {roles} from '../../ag-common/tools/roles'
import {usePermissions} from '#hooks/usePermissions'

const allAzubisSelector = state => state.azubis.allAzubis
const isLoadingSelector = state => !!state.azubis.loading.getAzubis
const hasAzubisSelector = state => state.authentication.permissions.meineAzubis.hasAzubis

export function useAzubiList() {
  const allAzubis = useSelector(allAzubisSelector, shallowEqual) || []
  const hasAzubis = useSelector(hasAzubisSelector)
  const isLoading = useSelector(isLoadingSelector)
  const permissions = usePermissions()
  const hasAbteilungsFilter = permissions.filter.hasAbteilungsFilter

  useEffect(() => {
    if (hasAzubis) {
      actions.azubis.getAzubis({
        loadGetAzubisWithAbteilungen: hasAbteilungsFilter,
      })
    }
  }, [hasAzubis])

  return {
    isLoading,
    allAzubis,
  }
}
